/** This file is auto-generated by extractThemeTypes.ts from the CSS theming in `crew-customer-ui`. Do not edit directly. */
/** Color Palette */
export const colorsProperties = [
    '--color-brand',
    '--color-on-brand',
    '--color-brand-container',
    '--color-on-brand-container',
    '--color-plain',
    '--color-on-plain',
    '--color-plain-container',
    '--color-on-plain-container',
    '--color-emphasis',
    '--color-on-emphasis',
    '--color-emphasis-container',
    '--color-on-emphasis-container',
    '--color-critical',
    '--color-on-critical',
    '--color-critical-container',
    '--color-on-critical-container',
    '--color-surface',
    '--color-surface-container-lowest',
    '--color-surface-container-low',
    '--color-surface-container',
    '--color-surface-container-high',
    '--color-surface-container-highest',
    '--color-on-surface',
    '--color-on-surface-variant',
    '--color-outline',
    '--color-outline-variant',
    '--color-inverse-surface',
    '--color-inverse-on-surface',
    '--color-scrim',
    '--color-shadow',
    '--state-disabled-mix',
    '--state-hovered-mix',
    '--state-active-mix',
    '--state-focused-mix',
    '--state-focused-outline-color',
    '--state-focused-outline-width',
    '--state-focused-outline-offset',
];
/** Elevation */
export const elevationProperties = ['--field-shadow'];
/**
 * CSS Utility Classes for Typography
 *
 * All classes apply: font-family, font-size, font-weight, line-height,
 * letter-spacing (where defined), font-variation-settings ('opsz'), and
 * text-transform (per role, inherited when unset; buttons use --button-text-transform).
 *
 * ┌──────────────┬────────┬────────┬─────────────┬───────────────────────────────────────────┐
 * │ Class        │ Size   │ Weight │ Line Height │ Common Usage                              │
 * ├──────────────┼────────┼────────┼─────────────┼───────────────────────────────────────────┤
 * │ heading-lg   │ 30px   │ normal │ 2.25rem     │ Tracking delivery status, page heroes     │
 * │ heading-md   │ 24px   │ normal │ 2rem        │ Page headlines (<h1>)                     │
 * │ heading-sm   │ 20px   │ normal │ 1.75rem     │ Modal titles, Card titles                 │
 * ├──────────────┼────────┼────────┼─────────────┼───────────────────────────────────────────┤
 * │ subheading-lg│ 18px   │ normal │ 1.75rem     │ Loading states, credit amounts            │
 * │ subheading-md│ 16px   │ medium │ 1.5rem      │ Section titles, headers                   │
 * │ subheading-sm│ 14px   │ medium │ 1.25rem     │ Disclosure summaries, alert titles        │
 * ├──────────────┼────────┼────────┼─────────────┼───────────────────────────────────────────┤
 * │ body-lg      │ 16px   │ normal │ 1.5rem      │ Form inputs, description lists            │
 * │ body-md      │ 14px   │ normal │ 1.25rem     │ General content, dropdowns, tooltips      │
 * │ body-sm      │ 12px   │ normal │ 1rem        │ Hints, badges, file names, small details  │
 * ├──────────────┼────────┼────────┼─────────────┼───────────────────────────────────────────┤
 * │ label-lg     │ 16px   │ medium │ 1.25rem     │ Buttons, form labels, line item titles    │
 * │ label-md     │ 14px   │ medium │ 1rem        │ Secondary labels, tracking shipment info  │
 * │ label-sm     │ 12px   │ medium │ 1rem        │ Smallest emphasized text                  │
 * └──────────────┴────────┴────────┴─────────────┴───────────────────────────────────────────┘
 *
 * Font Families:
 *   - Heading family (--font-heading-family): heading-*, subheading-lg
 *   - Body family (--font-body-family): subheading-md/sm, body-*, label-*
 *
 * @see apps/crew-customer-ui/src/main.css for full CSS variable definitions
 */
export const typographyProperties = [
    '--font-heading-family',
    '--font-body-family',
    '--heading-family-lg',
    '--heading-size-lg',
    '--heading-weight-lg',
    '--heading-leading-lg',
    '--heading-tracking-lg',
    '--heading-opsz-lg',
    '--heading-family-md',
    '--heading-size-md',
    '--heading-weight-md',
    '--heading-leading-md',
    '--heading-tracking-md',
    '--heading-opsz-md',
    '--heading-family-sm',
    '--heading-size-sm',
    '--heading-weight-sm',
    '--heading-leading-sm',
    '--heading-tracking-sm',
    '--heading-opsz-sm',
    '--subheading-family-lg',
    '--subheading-size-lg',
    '--subheading-weight-lg',
    '--subheading-leading-lg',
    '--subheading-tracking-lg',
    '--subheading-opsz-lg',
    '--subheading-family-md',
    '--subheading-size-md',
    '--subheading-weight-md',
    '--subheading-leading-md',
    '--subheading-tracking-md',
    '--subheading-opsz-md',
    '--subheading-family-sm',
    '--subheading-size-sm',
    '--subheading-weight-sm',
    '--subheading-leading-sm',
    '--subheading-tracking-sm',
    '--subheading-opsz-sm',
    '--body-family-lg',
    '--body-size-lg',
    '--body-weight-lg',
    '--body-leading-lg',
    '--body-tracking-lg',
    '--body-opsz-lg',
    '--body-family-md',
    '--body-size-md',
    '--body-weight-md',
    '--body-leading-md',
    '--body-tracking-md',
    '--body-opsz-md',
    '--body-family-sm',
    '--body-size-sm',
    '--body-weight-sm',
    '--body-leading-sm',
    '--body-tracking-sm',
    '--body-opsz-sm',
    '--label-family-lg',
    '--label-size-lg',
    '--label-weight-lg',
    '--label-leading-lg',
    '--label-tracking-lg',
    '--label-opsz-lg',
    '--label-family-md',
    '--label-size-md',
    '--label-weight-md',
    '--label-leading-md',
    '--label-tracking-md',
    '--label-opsz-md',
    '--label-family-sm',
    '--label-size-sm',
    '--label-weight-sm',
    '--label-leading-sm',
    '--label-tracking-sm',
    '--label-opsz-sm',
    '--heading-text-transform',
    '--subheading-text-transform',
    '--body-text-transform',
    '--label-text-transform',
    '--button-text-transform',
];
export const typographyUtilityClasses = [
    /** Utility Classes for heading-* */
    'heading-lg',
    'heading-md',
    'heading-sm',
    /** Utility Classes for subheading-* */
    'subheading-lg',
    'subheading-md',
    'subheading-sm',
    /** Utility Classes for body-* */
    'body-lg',
    'body-md',
    'body-sm',
    /** Utility Classes for label-* */
    'label-lg',
    'label-md',
    'label-sm',
];
/** Component `data-component` attribute values used in the Customer UI. */
export const dataComponentValues = [
    'corso-app-body',
    'corso-app-content',
    'corso-app-footer',
    'corso-app-header',
    'corso-app-shell',
    'corso-button',
    'corso-combobox',
    'corso-combobox-listbox',
    'corso-combobox-option',
    'corso-combobox-search',
    'corso-description-list',
    'corso-disclosure',
    'corso-divide',
    'corso-divider',
    'corso-dropzone',
    'corso-field',
    'corso-icon-button',
    'corso-input',
    'corso-link',
    'corso-media',
    'corso-page',
    'corso-page-section',
    'corso-product-filter-popover',
    'corso-product-image',
    'corso-product-search-popover',
    'corso-radio-button-option',
    'corso-radio-card-option',
    'corso-radio-group',
    'corso-textarea',
];
//# sourceMappingURL=theme.js.map